<mat-card style="padding-bottom: 10px;">
    <app-matspinner *ngIf="isLoading"></app-matspinner>
    <mat-card-header>
      <mat-card-title class="title">Directory Sync Search</mat-card-title>
    </mat-card-header>
    <mat-divider  class="divider" style="margin-bottom: 0%;"></mat-divider>
    <mat-card-content>
      <br>
      <!-- <div class="container"> -->
        <form [formGroup]="form" (ngSubmit)="submitForm()">
            <mat-accordion>
                <mat-expansion-panel (opened)="panelOpenState = true"
                (closed)="panelOpenState = false" [expanded]=true>
            <mat-expansion-panel-header style="height: 30px;">
            </mat-expansion-panel-header>
        <div class="container">
          <div class="row form-row">
            <div class="col-md-2">
              <label class="lbl_fld">File Date</label><span class="asterick">*</span>
            </div>
            <div class="col-md-4" style="position:relative;">
              <mat-form-field class="ffs" appearance="outline">
                <input
                  matInput
                  name="FileDate"
                  [matDatepicker]="datepicker"
                  formControlName="FileDate"
                  (dateChange)="onDateSelect($event)"
                  (keyup)="onDateInputkeyup($event)"
                  required
                  placeholder="MM/DD/YYYY"
                  [max]="maxFileDate"
                  autocomplete="off"
                >
                <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
                <mat-datepicker #datepicker></mat-datepicker>
                <mat-error *ngIf="errorMessageForFileDate">{{errorMessageForFileDate}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-6 button-row">
              <button
                [disabled]="!this.form.valid"
                mat-raised-button
                class="btn-save"
                type="submit"
              >Search</button>
              <button
                style="margin-left: 5%;"
                type="button"
                (click)="clearSearch()"
                mat-raised-button
                class="btn-cancel"
              >Clear</button>
            </div>
          </div>
        </div>
</mat-expansion-panel>
</mat-accordion>
        </form>
        <div class="store-search-row" *ngIf="dataSource!=null">
  <div class="form-group search-group">
    <mat-form-field class="ffs" appearance="outline" style="font-size: 18px; margin-left: 0%;">
      <input
        matInput
        type="text"
        (keyup)="applyFilter($event)"
        placeholder="Search"
        #input
        autocomplete="off"
      >
    </mat-form-field>
  </div>
  <div class="export-button" style="margin-right: 10%;">
    <button
      mat-raised-button
      type="button"
      class="btn-save"
      (click)="ExportToExcel()"
    >Export</button>
  </div>
</div>
        <div id="pharmacyStoreSyncResultTable" class="mat-elevation-z8  table-container" >
            <table mat-table [dataSource]="dataSource" matSort >

              <ng-container matColumnDef="ActionType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Action Type </th>
                <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.ActionType}} </td>
              </ng-container>
        
                <ng-container matColumnDef="NCPDPID">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> NCPDP ID </th>
                  <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.NCPDPID}} </td>
                </ng-container>

                <ng-container matColumnDef="NPI">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> NPI </th>
                  <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.NPI}} </td>
                </ng-container>
                
                <ng-container matColumnDef="PharmacyName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Current Pharmacy Chain </th>
                    <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.PharmacyName}} </td>
                  </ng-container>
        
                <ng-container matColumnDef="OldPharmacyName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Previous Pharmacy Chain </th>
                  <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.OldPharmacyName}} </td>
                </ng-container>
        
                <ng-container matColumnDef="ProcessFileDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Process File Date </th>
                  <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.ProcessFileDate}} </td>
                </ng-container>

                <ng-container matColumnDef="ProcessFileName">  
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Process File Name </th>
                  <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.ProcessFileName}} </td>
                </ng-container>

                <ng-container matColumnDef="ProcessDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Process Date </th>
                  <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.ProcessDate}} </td>
                </ng-container>
                
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: !isLoading?true:false"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">File processed. No updates necessary.</td>
      </tr>
              </table>
              <mat-paginator [pageSizeOptions]="[10, 20, 30, 100]" aria-label="Select page of users" [ngClass]="{'mat-paginator-sticky': !isLoading }">
              </mat-paginator>
        
            </div>
      <!-- </div> -->
    </mat-card-content>
    <br>
    <br>
  </mat-card>